import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
// import { Store } from 'redux';
// import { AppStore } from '../../app.store';
// import { UsersState } from '../../_model/user/user.reducer';
import { DailySignInService } from '../../components/dialogs/daily-sign-in/daily-sign-in.service';
import { pipe, Unsubscribable } from 'rxjs';
import { UserService } from '../../_service/user/user.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-daily-sign-in-button',
  templateUrl: './daily-sign-in-button.component.html',
  styleUrls: ['./daily-sign-in-button.component.scss']
})
export class DailySignInButtonComponent implements OnInit, OnDestroy {
  user;
  // private unsub = null;
  private subscriptions:Array<Unsubscribable> = [];
  mouseLeaveDelay = false;
  public expand = false;
  firstGet = true;
  signInData = {
    bonus_status: 0,
    bonus_day: 0,
    count_day: 0,
    bonus_list: [],
  };
  isLoading = false;
  lastId = null;

  constructor(
    // @Inject(AppStore) private store: Store<UsersState>,
    private signInService: DailySignInService,
    private _userService: UserService,
    private _router: Router,
  ) { }

  ngOnInit() {
 
    this.subscriptions.push(this._userService.userState$.subscribe((user) => {
      this.user = user;
      // this.readState();
      if (this.user.id === null || this.user.id == 0) { // 用户已退出或未登陆
        this.lastId = null;
      }
      if (this.user.id>0 && this.firstGet) {
        this.firstGet = false;
        this.isLoading = true;
        this.lastId = this.user.id;
        // if(environment.app)
        // {
        //   this.signInService.getSignInData(this.user.id).subscribe(res => {
        //     this.isLoading = false;
        //     this.signInData = res[0];
        //   });
        // }
        // else
        // {
        //   this.isLoading = false;
        // }
        // 网页重新启用签到
        this.signInService.getSignInData(this.user.id).subscribe(res => {
          this.isLoading = false;
          this.signInData = res[0];
        });
      }
      if (this.user && this.user.id !== this.lastId) {  // 切换用户后 初始化
        this.firstGet = true;
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(p=>p.unsubscribe());
    // if (this.unsub !== null) {
    //   this.unsub();
    // }
  }

  readState() {
    // const state: UsersState = this.store.getState()['users'] as UsersState;
    // this.user = state.currentUser;
  }

  mouseEnter() {
    this.mouseLeaveDelay = false;
    this.expand = true;
  }

  mouseLeave() {
    this.expand = false;

  }

  navToUser() {
    this._router.navigate(['/user']);
  }

}
